import {
  EnemCircleIcon,
  EnemIcon,
  FuvestIcon,
  UeaIcon,
  UeceIcon,
  UerjIcon,
  UfprIcon,
  UfrgsIcon,
  UfscIcon,
  UnespIcon,
  UnicampIcon,
} from 'morpheus-ui';
import { toast } from '../components/atoms/Toast';

export const getUniversityIcon = (university: string) => {
  switch (university) {
    case 'UFRGS':
      return UfrgsIcon;
    case 'UFSC':
      return UfscIcon;
    case 'UEA':
      return UeaIcon;
    case 'UERJ':
      return UerjIcon;
    case 'UNICAMP':
      return UnicampIcon;
    case 'UNESP':
      return UnespIcon;
    case 'UFPR':
      return UfprIcon;
    case 'FUVEST':
      return FuvestIcon;
    case 'UECE':
      return UeceIcon;
    case 'ENEM':
      return EnemCircleIcon;
    default:
      return EnemIcon;
  }
};

export const getPraticeTestResolutionTime = (
  numberOfQuestions: number,
  area?: string
) => {
  const timePerQuestion = area === 'fisica' || area === 'matematica' ? 5 : 3;

  const minutes = numberOfQuestions * timePerQuestion;
  let hoursString = '';
  let minString = '';

  if (minutes >= 120) {
    hoursString = `${Math.floor(minutes / 60)} horas`;
  } else if (minutes >= 60) {
    hoursString = `1 hora`;
  }

  const minRest = minutes % 60;
  if (minRest) {
    if (hoursString) {
      minString = ` e ${minRest} minutos`;
    } else {
      minString = `${minRest} minutos`;
    }
  }
  return hoursString + minString;
};

export const sizeConverter = (size: number) => {
  switch (size) {
    case 14:
      return 'small';
    case 16:
      return 'default';
    case 18:
      return 'large';
    default:
      return 'default';
  }
};

export const sizeInverseConverter = (size: string) => {
  switch (size) {
    case 'small':
      return 14;
    case 'default':
      return 16;
    case 'large':
      return 18;
    default:
      return 16;
  }
};

export const setTheme = (theme: string) => {
  if (theme === 'dark') {
    document.documentElement.classList.remove('light');
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add('light');
  }
};

export const copyText = (text: string) => {
  navigator.clipboard.writeText(text);
  toast({
    variant: 'success',
    title: 'Texto copiado',
    position: 'top-left',
  });
};

/**
 * Opens WhatsApp with a pre-filled message
 * The user can choose which contact to send the message to
 * @param message - The message to be shared
 */
export const shareOnWhatsApp = (message: string) => {
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
  window.open(whatsappUrl, '_blank');
};
